import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 101513 62117"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:1471.2}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275641872">
        <path
          d="M33445 1724c1320 1318 1320 3455 0 4774-1317 1319-3455 1319-4773 0-1318-1318-1318-3456 0-4774 1317-1318 3456-1318 4773 0zM24462 10706c1318 1318 1318 3456 0 4773-1319 1316-3455 1316-4773 0-1318-1320-1318-3456 0-4773 1318-1318 3454-1318 4773 0zM15479 19689c1319 1318 1319 3456 0 4773-1317 1318-3455 1318-4772 0-1318-1317-1318-3455 0-4773 1316-1320 3455-1320 4772 0zM6497 28671c1317 1318 1317 3454 0 4774-1320 1318-3456 1318-4774 0-1317-1320-1317-3456 0-4774 1318-1317 3456-1317 4774 0zM33445 60391c1320-1316 1320-3453 0-4772-1317-1318-3455-1318-4773 0-1318 1319-1318 3456 0 4772 1317 1320 3456 1320 4773 0zM24462 51410c1318-1318 1318-3456 0-4773-1319-1320-3455-1320-4773 0-1318 1318-1318 3456 0 4773 1318 1318 3454 1318 4773 0zM15479 42428c1319-1320 1319-3456 0-4773-1317-1319-3455-1319-4772 0-1318 1317-1318 3453 0 4773 1316 1317 3455 1317 4772 0z"
          className="fill stroke1"
          style={{
            strokeWidth: 1471.2,
          }}
        />
        <path
          d="M6497 33445c1317-1320 1317-3456 0-4774-1320-1318-3456-1318-4774 0-1317 1318-1317 3454 0 4774 1318 1318 3456 1318 4774 0z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1471.2,
          }}
        />
      </g>
      <g id="_1970275646512">
        <path
          d="M62667 31057c0 1866-1511 3377-3375 3377-1865 0-3375-1511-3375-3377 0-1862 1511-3375 3375-3375 1863 0 3375 1513 3375 3375zM49964 31057c0 1866-1511 3377-3377 3377-1861 0-3373-1511-3373-3377 0-1862 1512-3375 3373-3375 1866 2 3377 1513 3377 3375zM37261 31057c0 1866-1511 3377-3375 3377s-3375-1511-3375-3377c0-1862 1510-3375 3375-3375 1864 2 3375 1513 3375 3375zM24557 31057c0 1866-1512 3377-3375 3377-1864 0-3376-1511-3376-3377 0-1862 1511-3375 3376-3375 1863 2 3375 1513 3375 3375z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1471.2,
          }}
        />
      </g>
      <g id="_1970275646896">
        <path
          d="M100777 31057c0 1866-1511 3377-3375 3377-1862 0-3373-1511-3373-3377 0-1862 1511-3375 3373-3375 1864 2 3375 1513 3375 3375zM88075 31057c0 1866-1511 3377-3376 3377-1863 0-3374-1511-3374-3377 0-1862 1511-3375 3374-3375 1865 2 3376 1513 3376 3375zM75370 31057c0 1866-1510 3377-3374 3377s-3375-1511-3375-3377c0-1862 1511-3375 3375-3375 1863 2 3374 1513 3374 3375z"
                    className="fill stroke1"
          style={{
            strokeWidth: 1471.2,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
